(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["alr-produse-rand"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const scrollers = () => {
      document.querySelectorAll('.alr-rand:not([data-alr-init])').forEach((root) => {
        root.dataset.alrInit = '1';
        const lista = root.querySelector('.alr-rand__lista');
        root.querySelectorAll('.alr-rand__btn').forEach((btn) =>
          btn.addEventListener('click', () => {
            lista.scrollBy({ left: Number(btn.dataset.dir) * lista.clientWidth * 0.9, behavior: 'smooth' });
          })
        );
      });
    };

    const KEY = 'alr_recente';
    const read = () => {
      try {
        return JSON.parse(localStorage.getItem(KEY) || '[]');
      } catch (e) {
        return [];
      }
    };
    const write = (list) => {
      try {
        localStorage.setItem(KEY, JSON.stringify(list));
      } catch (e) {}
    };

    const recente = async () => {
      const root = document.querySelector('[data-alr-recente]:not([data-alr-loaded])');
      if (!root) return;
      root.dataset.alrLoaded = '1';
      const current = root.dataset.current;
      const max = Number(root.dataset.max) || 12;
      const prev = read().filter((h) => h && h !== current);
      const handles = prev.slice(0, max);
      if (!handles.length) return;
      const base = window.Shopify?.routes?.root || '/';
      const html = await Promise.all(
        handles.map((h) =>
          fetch(`${base}products/${h}?section_id=alr-mini-card`)
            .then((r) => (r.ok ? r.text() : ''))
            .catch(() => '')
        )
      );
      const lista = root.querySelector('.alr-rand__lista');
      const parser = new DOMParser();
      html.forEach((t) => {
        if (!t) return;
        const li = parser.parseFromString(t, 'text/html').querySelector('.alr-rand__item');
        if (li) lista.append(li);
      });
      if (lista.children.length) root.hidden = false;
    };

    // „Vizualizate recent” e la finalul paginii: cardurile se aduc doar când vizitatorul ajunge aproape de ea
    const recenteLazy = () => {
      const root = document.querySelector('[data-alr-recente]:not([data-alr-loaded])');
      if (!root) return;
      const conn = navigator.connection || {};
      const current = root.dataset.current;
      if (conn.saveData || /(^|-)2g$/.test(conn.effectiveType || '')) {
        // pe net foarte lent doar ținem minte produsul, fără să aducem carduri
        if (current) write([current, ...read().filter((h) => h && h !== current)].slice(0, 20));
        root.dataset.alrLoaded = '1';
        return;
      }
      const sentinel = root.parentElement || root;
      if (!('IntersectionObserver' in window)) return recente();
      const io = new IntersectionObserver(
        (entries) => {
          if (!entries.some((e) => e.isIntersecting)) return;
          io.disconnect();
          (window.requestIdleCallback || setTimeout)(() => recente());
        },
        { rootMargin: '600px' }
      );
      io.observe(sentinel);
      // produsul curent se ține minte imediat, chiar dacă vizitatorul nu derulează până jos
      if (current) write([current, ...read().filter((h) => h && h !== current)].slice(0, 20));
    };

    scrollers();
    recenteLazy();
    document.addEventListener('shopify:section:load', () => {
      scrollers();
      recenteLazy();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
